import React from 'react';
import './App.scss';

import Board from 'components/Board';

function App() {
  return (
    <div id="app">
      <header>Magic Board</header>

      <Board />
    </div>
  );
}

export default App;
